import React from "react";

import AppPage from "@/ui/AppPage/AppPage";
import MainMap from "@/views/GIS/MapPage/MainMap";

import { Permissions } from "@/lib/permissions";
import MapRoutingProvider from "@/components/MapRoutingContext/MapRoutingProvider";

function HGSSMapPage() {

  return (
    <AppPage needPermission={[Permissions.HGSSRead]}>
      <MapRoutingProvider>
        <MainMap mapId={200} />
      </MapRoutingProvider>
    </AppPage>
  );
}

export default HGSSMapPage;
